import { render, staticRenderFns } from "./pre-activity.vue?vue&type=template&id=1240f453"
import script from "./pre-activity.vue?vue&type=script&lang=js"
export * from "./pre-activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports